import { render, staticRenderFns } from "./PromotionUpdateDialog.vue?vue&type=template&id=7c2c84ea&scoped=true"
import script from "./PromotionUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./PromotionUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c84ea",
  null
  
)

export default component.exports